import { render, staticRenderFns } from "./RoomService.vue?vue&type=template&id=4a6177d5&scoped=true&"
import script from "./RoomService.vue?vue&type=script&lang=js&"
export * from "./RoomService.vue?vue&type=script&lang=js&"
import style0 from "./RoomService.vue?vue&type=style&index=0&id=4a6177d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6177d5",
  null
  
)

export default component.exports